import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import { postData } from "../../../backend/api";
import AutoForm from "../../elements/form";
import Footer from "../footer/index2";
import { FormContainer, MainContainer, SignUpLink } from "./styles";
//using translation
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import withLayout from "../layout";
import { ColumnContainer } from "../../styles/containers/styles";
import Header from "../header";
import { clearLoginSession, fetchLogin } from "../../../store/actions/login";
import LanguageTooltip from "../../elements/tooltip";
import { exportPrivateKeyToPEM, exportPublicKeyToPEM, generateUserKeyPair, lockPrivateKeyInVault, unlockPrivateKeyFromVault } from "../../functions/cryptoUtils";
import { putData } from "../../../backend/api";
import { useSecurity } from "../../../context/SecurityContext";

const SignUpPageLink = ()=>{
  const { t } = useTranslation();
  return(
    <SignUpLink>
      {t("Don't have an account?")} <Link style={{color:'#15629A'}} to="/sign-up">{t('Sign Up')}</Link>
    </SignUpLink>
  )
}

const ForgetPassword = ()=>{
  const { t } = useTranslation();
  return(<Link style={{color:'#15629A',textDecoration:'none'}} to="/forget-password">{t('Forget Password')}</Link>
  )
}

const Login = (props) => {
  useEffect(() => {
    document.title = `${t("login")} - Whistleblowing24`;
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const { t } = useTranslation();

  const { saveIdentity } = useSecurity();

  const [formInput] = useState([
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      minimum: 5,
      maximum: 40,
      required: true,
    },
    {
      type: "password",
      placeholder: "password",
      name: "password",
      validation: "password",
      default: "",
      label: "password",
      // minimum: 6,
      // maximum: 15,
      required: true,
    },
    // {
    //   type: "checkbox",
    //   placeholder: "Remember me",
    //   name: "rememberMe",
    //   validation: "rememberMe",
    //   default: "",
    //   label: "Remember me",
    // },
  ]);
  const { setLoaderBox } = props;
  useEffect(() => {
    if (user.data?.token) {
      navigate(user.data?.menu[0]?.path ?? "dashboard");
    }
    setLoaderBox(user.isLoading);
    if (user.error !== null) {
      props.setMessage({ type: 1, content: t(user.error), proceed: "Okay", code: 400 });
      dispatch(clearLoginSession());
    }
  }, [user, navigate, setLoaderBox, t, props, dispatch]);

  const isCreatingHandler = (value, callback) => {};
  const submitChange = async (post) => {
    // 1. Wait for the Redux action to fully complete and return the payload
    // Note: Ensure your fetchLogin action actually returns the payload!
    const actionResult = await dispatch(fetchLogin(post));
    
    // Redux Toolkit 'unwrap()' or accessing payload directly depending on your setup
    // Assuming actionResult.payload or actionResult is the data:
    const data = actionResult.payload || actionResult; 

    if (!data || !data.user) return;

    try {
        // CASE A: NEW USER (No Keys yet) -> Generate & Save
        if (!data.user.encrypted_identity?.private_key || !data.user.public_key) {
            console.log("Generating new identity...");

            const userRes = await generateUserKeyPair();
            const userPublicKeyPEM = await exportPublicKeyToPEM(userRes.publicKey);

            // Encrypt the new private key with the password
            const userIdentity = await lockPrivateKeyInVault(
                userRes.privateKey,
                post.password
            );

            const payload = {
                public_key: userPublicKeyPEM,
                encrypted_identity: {
                    private_key: userIdentity.encryptedBlob,
                    iv: userIdentity.iv,
                    salt: userIdentity.salt,
                },
            };

            // Save to Backend
            await putData(payload, `user/${data.user._id}`, dispatch, navigate);

            // Save to Session (We already have the raw key, no need to decrypt!)
            const privateKeyString = await exportPrivateKeyToPEM(userRes.privateKey);
            saveIdentity(privateKeyString);
        } 
        
        // CASE B: EXISTING USER -> Unlock Keys
        else {
            console.log("Unlocking existing identity...");
            
            const decryptPvtObj = await unlockPrivateKeyFromVault(
                data.user.encrypted_identity.private_key,
                post.password,
                data.user.encrypted_identity.salt,
                data.user.encrypted_identity.iv
            );

            const privateKeyString = await exportPrivateKeyToPEM(decryptPvtObj);
            saveIdentity(privateKeyString);
        }

        // Navigate after successful key setup
        // navigate('/dashboard'); 

    } catch (error) {
        console.error("Crypto Error:", error);
        // Handle wrong password or data corruption here
        // alert("Failed to unlock your security vault. Did you change your password elsewhere?");
    }
  };


  return (
    <MainContainer>
      <Header> </Header>
      <ColumnContainer className="login">
        <FormContainer className="login">
          <AutoForm enterSubmit={true} useCaptcha={false} formType={"post"} description={t("loginDescription")} header={t("Log in")} formInput={formInput} submitHandler={submitChange} button={t("validate")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} ForgetPassword={ForgetPassword} login={"loginForm"} isLanguage={true} page={"login"} ></AutoForm>
          {/* <div style={{marginTop:'10px',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <LanguageTooltip page={"login"} />
          </div> */}
          <SignUpLink>
            {t("Don't have an account?")} <Link to="/sign-up">{t('Start now')}</Link>
          </SignUpLink>
        </FormContainer>

      </ColumnContainer>
      {/* <Footer></Footer> */}
    </MainContainer>
  );
};

export default withLayout(Login);
